import isInt from "validator/es/lib/isInt";
import isUUID from "validator/es/lib/isUUID";

import { RouteParam } from "./IRoute";

export const uuid = (param: `:${string}`): RouteParam => ({
    param,
    matches: value => isUUID(value),
});

export const mode = (
    actual: string,
    param: `:${string}` = ":mode",
): RouteParam => ({
    param,
    matches: value => value === actual,
});

export const integer = (param: `:${string}`): RouteParam => ({
    param,
    matches: val => isInt(val),
});
